module.exports = __webpack_public_path__ + "media/assets/avatars/hokenplanner-img2-66acadce55ec6336fa915c6a11d8fa2d.svg";